import { render } from "./YellowCompanyRegister.vue?vue&type=template&id=de748c14"
import script from "./YellowCompanyRegister.vue?vue&type=script&lang=js"
export * from "./YellowCompanyRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__